import { render, staticRenderFns } from "./ProductAssetsList.vue?vue&type=template&id=50c0a2b5&"
import script from "./ProductAssetsList.vue?vue&type=script&lang=js&"
export * from "./ProductAssetsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports